export const createRegisterFormData = (data, fcmToken, isUpdate = false) => {
  const formData = new FormData();

  formData.append("user_name", data.name || "");
  formData.append("user_address", data.street || "");
  formData.append("user_state", data.state || "");
  formData.append("user_zipcode", data.zip || "");
  formData.append("user_email", data.email || "");
  formData.append("user_password", data.password || "");
  formData.append("user_phone", data.phone || "");
  formData.append("user_bio", data.userBio || "");
  formData.append("user_city", data.city || "");
  formData.append("user_address_line_2", data.apartment || "");
  formData.append("neighborhood", data.neighborhood || "");

  if (data.user_latitude) formData.append("user_latitude", data.user_latitude);
  if (data.user_longitude)
    formData.append("user_longitude", data.user_longitude);

  formData.append(
    "user_dog_status",
    data.user_dog_status !== undefined
      ? data.user_dog_status
      : data.team === "paws",
  );
  formData.append(
    "team_paws",
    data.team_paws !== undefined ? data.team_paws : data.team === "paws",
  );
  formData.append(
    "team_social",
    data.team_social !== undefined ? data.team_social : data.team === "social",
  );
  formData.append(
    "isDogProfileComplete",
    data.isDogProfileComplete !== undefined ? data.isDogProfileComplete : false,
  );
  formData.append(
    "isDogProfileHalfComplete",
    data.isDogProfileHalfComplete !== undefined
      ? data.isDogProfileHalfComplete
      : false,
  );

  let bringsYouHere = data.selectedBringsYouHere || [];
  if (typeof bringsYouHere === "string") {
    try {
      bringsYouHere = JSON.parse(bringsYouHere);
    } catch {
      bringsYouHere = [bringsYouHere];
    }
  }
  if (!Array.isArray(bringsYouHere)) {
    bringsYouHere = typeof bringsYouHere === "string" ? [bringsYouHere] : [];
  }
  const cleanWhatsBringsYou = bringsYouHere.filter(
    (item) =>
      typeof item === "string" &&
      item.trim() !== "" &&
      item.trim() !== "[" &&
      item.trim() !== "]",
  );
  formData.append("whats_brings_you", JSON.stringify(cleanWhatsBringsYou));

  formData.append("dog_hobbies", JSON.stringify(data.selectedHobbies || []));

  if (!isUpdate && data.photos) {
    if (data.photos.main) {
      formData.append("images", data.photos.main);
      formData.append("image_index", 0);
    }
    if (data.photos.sub1) {
      formData.append("images", data.photos.sub1);
      formData.append("image_index", 1);
    }
    if (data.photos.sub2) {
      formData.append("images", data.photos.sub2);
      formData.append("image_index", 2);
    }
    if (data.photos.sub3) {
      formData.append("images", data.photos.sub3);
      formData.append("image_index", 3);
    }
  }

  if (fcmToken) {
    formData.append("fcm_token", fcmToken);
  }

  return formData;
};

export const createLoginPayload = (email, password) => {
  return {
    user_email: email,
    user_password: password,
  };
};
